export enum FileUploadType{
    UNKNOWN, 
    BUSINESSBANNERIMAGE
}